"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeSchema = void 0;
const mergeSchema = (schema, properties) => {
    return Object.assign(Object.assign({}, schema), { properties: [...schema.properties, ...properties].filter((obj, index, array) => {
            var _a;
            const objPropertyNameOrId = (_a = obj.propertyName) !== null && _a !== void 0 ? _a : obj.propertyId;
            return (array.findIndex((item) => {
                var _a;
                const itemPropertyNameOrId = (_a = item.propertyName) !== null && _a !== void 0 ? _a : item.propertyId;
                return itemPropertyNameOrId === objPropertyNameOrId;
            }) === index);
        }) });
};
exports.mergeSchema = mergeSchema;
